import store from "@/store";
import { AUTH_URL, IS_DEV } from "@/config";

export default ({ router, next }) => {
  if (!store.getters.user) {
    if (store.getters.isForbidden) {
      return router.push("/auth/forbidden");
    } else if (IS_DEV) return router.push({ name: "login" });
    else return (window.location.href = AUTH_URL);
  }
  return next();
};
